import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Modules Material utilises
import { MatMenuModule } from '@angular/material/menu';

// Autres modules externes utilises 

// Modules communs utilises
import { EventsModule } from '../../technical-modules/events/event-bus.module';
import { JSR310LocalDatesModule } from '../../shared/jsr310-localdates/jsr310-localdates.module';

// Composants metiers
import { BatchsMonitorComponent } from './component/batchs-monitor.component';

// Services metier
import { OngoingBatchService } from './services/ongoing-batchs.service';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,

		MatMenuModule,
		
		EventsModule,
		JSR310LocalDatesModule,
	],
	providers: [
		OngoingBatchService,
	],
	declarations: [
		BatchsMonitorComponent,
	],
	exports: [
	]
})
export class BatchsMonitorModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('batchsMonitor',
		downgradeComponent({ component: BatchsMonitorComponent })
	) //
;